/**
 * Resolve the best post-login / logo home path from the user's permissions.
 * Prefer POS for cashiers; accountant dashboard for number-checkers; then
 * standard list pages (orders → customers → products).
 */
export function resolveHomePath(permissions = [], isAdmin = false) {
  const list = Array.isArray(permissions) ? permissions : [];
  const set = new Set(list.map((p) => String(p)));
  const has = (p) => isAdmin || set.has(p);

  if (has("pos.sell")) return "/pos";
  if (has("orders.index")) return "/orders";
  if (has("reports.view")) return "/reports/accountant";
  if (has("reports.audit")) return "/audit";
  if (has("reports.unpaid_sales")) return "/unpaid-sales";
  if (has("customers.index")) return "/customers";
  if (has("vendors.index") || has("vendors.finance")) return "/vendors";
  if (
    has("company_expenses.view")
    || has("company_expenses.add")
    || has("company_expenses.cancel")
    || has("company_expenses.manage")
  ) {
    return "/company-expenses";
  }
  if (has("products.index")) return "/products";
  if (has("users.index")) return "/users";
  if (has("roles.index")) return "/roles";
  return "/customers";
}

/** Same as resolveHomePath, reading the current browser session. */
export function readSessionHomePath() {
  let permissions = [];
  let isAdmin = false;
  try {
    const raw = localStorage.getItem("sessionPermissions");
    permissions = raw ? JSON.parse(raw) : [];
  } catch {
    permissions = [];
  }
  try {
    const user = JSON.parse(localStorage.getItem("sessionUser") || "null");
    isAdmin = user?.role === "admin";
  } catch {
    isAdmin = false;
  }
  return resolveHomePath(permissions, isAdmin);
}

const homePathApi = { resolveHomePath, readSessionHomePath };
export default homePathApi;
